import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/* Formats an ISO timestamp as a short localized "Mon D, YYYY" string.
   Returns "—" for null / undefined / invalid inputs so it's safe to drop
   into a table cell without conditional rendering.  */
export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch (_) { return "—"; }
}
